(ns ductile.base64u
  "Functions for encoding/decoding url-safe base64"
  #?(:clj (:import (java.util Base64))))

(defn encode [s]
  #?(:clj  (let [bytes (.getBytes s "UTF-8")]
             (String. (.encode (.withoutPadding (Base64/getUrlEncoder)) bytes)))
     ;; TODO: use this once we're sure everyone uses a supported browser
     ;; https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Uint8Array/toBase64
     ;; (.toBase64 (.encode (js/TextEncoder.) s) #js {:alphabet "base64url"})
     :cljs (let [utf8-bytes (.encode (js/TextEncoder.) s)
                 binary-str (apply str (map #(js/String.fromCharCode %) utf8-bytes))]
             (-> (js/btoa binary-str)
                 (.replaceAll "=" "")
                 (.replaceAll "+" "-")
                 (.replaceAll "/" "_")))))

(defn decode [s]
  #?(:clj  (let [decoded-bytes (.decode (Base64/getUrlDecoder) s)]
             (String. decoded-bytes "UTF-8"))
     ;; TODO: use this once we're sure everyone uses a supported browser
     ;; https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Uint8Array/fromBase64
     ;; (.decode (js/TextDecoder.) (js/Uint8Array.fromBase64 s #js {:alphabet "base64url"}))
     :cljs (let [normalized (-> s
                                (.replaceAll "-" "+")
                                (.replaceAll "_" "/")
                                (str (apply str (repeat (mod (- 4 (mod (count s) 4)) 4) "="))))
                 binary-str (js/atob normalized)
                 bytes (js/Uint8Array.from binary-str #(.charCodeAt % 0))]
             (.decode (js/TextDecoder.) bytes))))


(comment
  (decode (encode "Hello, world!"))
  (decode (encode "👍"))
  (= "{:transport/license-plate \"WÃ-NE73\"}" (decode (encode "{:transport/license-plate \"WÃ-NE73\"}")))
  (= "{:transport/license-plate \"WÜ-NE73\"}" (decode (encode "{:transport/license-plate \"WÜ-NE73\"}")))
  (= "YSDEgCDwkICAIOaWhyDwn6aE" (encode "a Ā 𐀀 文 🦄"))
  (= "a Ā 𐀀 文 🦄" (decode "YSDEgCDwkICAIOaWhyDwn6aE")))
